import { ax } from '../../AxiosFactory'

const submitReview = async (obj) => {
  const res = await ax.post('/review/', obj)
  return res
}

export { submitReview }
